import Vue from 'vue';
import Router from 'vue-router';
import VideoHome from './views/VideoHome';
import Booking from './views/Booking';
import AppointmentConfirmation from './views/AppointmentConfirmation';
import AppointmentError from './views/Iframe/AppointmentError';
import SecurePayment from './views/Iframe/SecurePayment';
import PaymentSuccessful from './views/Iframe/PaymentSuccessful';
import PaymentUnsuccessful from './views/Iframe/PaymentUnsuccessful';

Vue.use(Router);

const homeComponent = () => {
    const hasPartner = Boolean(process.env.VUE_APP_PARTNER_NAME);
    if (hasPartner) {
        return import('./views/Home.vue');
    } else {
        return import('./views/AscentiHome.vue');
    }
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: homeComponent
        },
        {
            path: '/video',
            name: 'video-home',
            component: VideoHome
        },
        {
            path: '/booking',
            name: 'booking',
            component: Booking
        },
        {
            path: '/secure-payment',
            name: 'secure-payment',
            component: SecurePayment
        },
        {
            path: '/payment/successful',
            name: 'payment-successful',
            component: PaymentSuccessful
        },
        {
            path: '/payment/unsuccessful',
            name: 'payment-unsuccessful',
            component: PaymentUnsuccessful
        },
        {
            path: '/confirmation',
            name: 'appointment-confirmation',
            component: AppointmentConfirmation
        },
        {
            path: '/confirmation/error',
            name: 'appointment-error',
            component: AppointmentError
        },
        {
            path: '*',
            component: {
                template: '',
                created: () => window.location.href = '/errors/404.html',
            },
        },
    ],
});
